import React, { useEffect, useState } from "react";
import { CustomDialog } from "../../CustomDialog";
import { useTranslate } from "../../../../Hooks";
import {
  ContactEmailDialog,
  ContactSMSDialog,
} from "./ContactsPreferenceDialogs";
import {
  GetContacts,
  SendBulkSmsPost,
  SendCorrespondingEmailPost,
} from "../../../../Services";
import { useVerticalNav } from "../../../../Contexts/VerticalNavContext";

function ContactPreferenceComponents({
  isOpenChanged,
  actionEnum,
  isOpen,
  activeItem,
}) {
  const { translate } = useTranslate("NewContactsView");
  const [state, setState] = useState({
    contacts: [],
    message: "",
    subject: "",
    messageKeyValue: {},
    files: [],
    bcc: [],
    ccc: [],
  });

  const [contactList, setContactList] = useState([]);
  const [selected, setSelected] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const { setAlertBoxContent } = useVerticalNav();

  const onSubmitHandler = async (preferenceAPI, submissionData) => {
    setIsLoading(true);
    try {
      await preferenceAPI(submissionData);
      isOpenChanged();
      resetState();
      setAlertBoxContent({
        display: true,
        variant: "success",
        title: "Email Send Successfully",
        onClose: () => {
          setAlertBoxContent(null);
        },
      });
    } catch (error) {
      setAlertBoxContent({
        display: true,
        variant: "error",
        title: "Email Send Failed",

        onClose: () => {
          setAlertBoxContent(null);
        },
      });
    } finally {
      setIsLoading(false);
    }
  };

  const getContacts = async (search) => {
    try {
      const response = await GetContacts({
        pageIndex: 0,
        pageSize: 100,
        isAdvance: false,
        search,
      });

      if (Array.isArray(response?.result)) {
        setContactList(response.result);
      } else {
        setContactList([]);
      }
    } catch (error) {
      console.error("Error fetching contacts:", error);
    }
  };

  const resetState = () => {
    setState({
      contacts: [],
      message: "",
      subject: "",
      messageKeyValue: {},
      files: [],
      bcc: [],
      ccc: [],
    });
    setContactList([]);
  };

  useEffect(() => {
    if (!isOpen) {
      resetState();
    }
  }, [isOpen]);
  useEffect(() => {
    if (!activeItem) return;
    setSelected([
      {
        contactsId: activeItem?.id || activeItem?.contactId,
        contact: {
          first_name:
            activeItem?.allDetails?.["Main Information"]?.[1]?.value ||
            activeItem?.["allDetails.Main Information"]?.[1]?.value ||
            activeItem?.first_name,
          last_name:
            activeItem?.allDetails?.["Main Information"]?.[2]?.value ||
            activeItem?.["allDetails.Main Information"]?.[2]?.value ||
            activeItem?.last_name,
          company_name: activeItem?.name || activeItem?.company_name,
        },
      },
    ]);
    setState((items) => ({
      ...items,
      contacts: [activeItem?.id],
    }));
  }, [activeItem, isOpen]);
  return (
    <>
      <CustomDialog
        open={isOpen}
        onClose={() => {
          isOpenChanged();
          resetState();
        }}
        title={
          actionEnum === "smsSolid"
            ? translate("send-sms")
            : translate("send-email")
        }
        subtitle={
          actionEnum === "smsSolid"
            ? translate("reach-out-sms")
            : translate("reach-out-email")
        }
        confirmText={translate("send")}
        width={"688px"}
        isDisabled={state.contacts.length === 0 || !state.message || isLoading}
        onConfirm={() => {
          const api =
            actionEnum === "smsSolid"
              ? SendBulkSmsPost
              : SendCorrespondingEmailPost;
          onSubmitHandler(api, state);
        }}
        content={
          (actionEnum === "smsSolid" && (
            <ContactSMSDialog
              setState={setState}
              getContacts={getContacts}
              contactList={contactList}
              state={state}
              setSelected={setSelected}
              selected={selected}
            />
          )) ||
          (actionEnum === "emailSolid" && (
            <ContactEmailDialog
              setState={setState}
              getContacts={getContacts}
              contactList={contactList}
              state={state}
              setSelected={setSelected}
              selected={selected}
            />
          ))
        }
      />
    </>
  );
}

export default ContactPreferenceComponents;
